
import {NotFoundComponent} from '../not-found/not-found.component';
import {MainMenuComponent} from './main-menu/main-menu.component';
import {BasicInformationComponent} from './basic-information/basic-information.component';
import {CreateIntroductionLetterComponent} from './create-introduction-letter/create-introduction-letter.component';
import {RoleGuard} from '../../services/guards/role-guard.service';
import {NewRequestComponent} from './new-request/new-request.component';
import {SubsetRequestsComponent} from './subset-requests/subset-requests.component';

export const IntroductionLetterRoutes = [
  {
    path: 'insurance-service',
    children: [
      {
        path: ':productName',
        component: MainMenuComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      },
      {
        path: ':productName/basic-information',
        component: BasicInformationComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      },
      {
        path: ':productName/new-request',
        component: NewRequestComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      },
      {
        path: ':productName/create',
        component: CreateIntroductionLetterComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      },
      {
        path: ':productName/details',
        component: SubsetRequestsComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }
];
